module.exports = __webpack_public_path__ + "static/media/pencil-alt.12232c72.svg";